import moment from 'moment'
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Loader } from '../../Common/Loader'
import Pagination from '../../Common/Pagination'
import { acceptDeposit, getDepositList, getFinanceSummary, rejectDeposit } from '../../service/service'

const STATUS_CLASS = { PENDING: 'pending', APPROVE: 'success', REJECT: 'danger' }

const PendingDeposits = () => {
    const navigate = useNavigate()
    const [loader, setLoader] = useState(false)
    const [statusFilter, setStatusFilter] = useState('PENDING')
    const [startDate, setStartDate] = useState('')
    const [endDate, setEndDate] = useState('')
    const [depositList, setDepositList] = useState([])
    const [summary, setSummary] = useState(null)
    const [search, setSearch] = useState('')
    const [page, setPage] = useState(1)
    const PAGE_SIZE = 10

    useEffect(() => {
        handleGetDeposits('PENDING')
    }, [])

    const handleGetDeposits = (depositStatus = statusFilter, sd = startDate, ed = endDate) => {
        setLoader(true)
        getFinanceSummary(sd || undefined, ed || undefined).then((res) => {
            setSummary(res.data?.data || null)
        }).catch(() => { })
        getDepositList(depositStatus, sd || undefined, ed || undefined).then((res) => {
            if (res.data?.status === false) {
                alert(res.data?.message || "something went wrong ")
            }
            setDepositList(res.data?.data || [])
            setLoader(false)
        }).catch((err) => {
            setLoader(false)
            alert(err?.response?.data?.message || "something went wrong ")
        })
    }

    const handleAction = (item, action) => {
        const verb = action === 'APPROVE' ? 'Approve' : 'Reject'
        if (!window.confirm(`${verb} ₹${item?.amount} deposit from ${item?.user_id__first_name || 'user'} (${item?.user_id__phone_number || 'NA'})?`)) {
            return
        }
        setLoader(true)
        const request = action === 'APPROVE' ? acceptDeposit : rejectDeposit
        request({ deposit_id: item?.id }).then((res) => {
            setLoader(false)
            if (res.data?.status === false) {
                alert(res.data?.message || "something went wrong ")
            }
            handleGetDeposits()
        }).catch((err) => {
            setLoader(false)
            alert(err?.response?.data?.message || "something went wrong ")
        })
    }

    const handleReset = () => {
        setStartDate('')
        setEndDate('')
        setPage(1)
        handleGetDeposits(statusFilter, '', '')
    }

    const filteredList = depositList?.filter(item =>
        (item?.user_id__first_name?.toLowerCase() || '').includes(search.toLowerCase()) ||
        (item?.user_id__phone_number?.toString() || '').includes(search) ||
        (item?.transaction_id || '').toLowerCase().includes(search.toLowerCase())
    )
    const totalAmount = filteredList?.reduce((sum, item) => sum + (parseFloat(item?.amount) || 0), 0)
    const totalPages = Math.ceil((filteredList?.length || 0) / PAGE_SIZE)
    const pagedList = filteredList?.slice((page - 1) * PAGE_SIZE, page * PAGE_SIZE)

    return (
        <>
            {loader ? <Loader /> : null}
            <div className="content-wrapper">
                <div className='container-fluid'>
                    <div className='card p-3 flex align-center space-between mb-3'>
                        <h4 className="card-title text-left w-100 mb-4">Deposit Requests</h4>
                        <div className='row w-100 align-items-end'>
                            <div className='form-group col-md-2'>
                                <label className="mb-1" style={{ fontSize: '16px' }}>Status</label>
                                <select className="form-control" value={statusFilter} onChange={(e) => { setStatusFilter(e.target.value); setPage(1); handleGetDeposits(e.target.value) }}>
                                    <option value="PENDING">Pending</option>
                                    <option value="APPROVE">Approved</option>
                                    <option value="REJECT">Rejected</option>
                                    <option value="ALL">All</option>
                                </select>
                            </div>
                            <div className='form-group col-md-3'>
                                <label className="mb-1" style={{ fontSize: '16px' }}>Start Date</label>
                                <input type="date" className='form-control' value={startDate} onChange={(e) => setStartDate(e.target.value)} />
                            </div>
                            <div className='form-group col-md-3'>
                                <label className="mb-1" style={{ fontSize: '16px' }}>End Date</label>
                                <input type="date" className='form-control' value={endDate} onChange={(e) => setEndDate(e.target.value)} />
                            </div>
                            <div className='form-group col-md-2'>
                                <button type="submit" className="btn btn-danger btn-block" onClick={() => { setPage(1); handleGetDeposits() }}>Search</button>
                            </div>
                            <div className='form-group col-md-2'>
                                <button type="button" className="btn btn-secondary btn-block" onClick={handleReset}>Reset</button>
                            </div>
                        </div>
                    </div>

                    {summary && (
                        <div className='card p-3 mb-3'>
                            <h4 className="card-title text-left w-100 mb-3">Overview{startDate && endDate ? ` (${moment(startDate).format('DD-MM-YYYY')} to ${moment(endDate).format('DD-MM-YYYY')})` : ' (All Time)'}</h4>
                            <div className='row w-100'>
                                {[
                                    { label: 'Auto Deposits', value: summary.deposits_auto, color: '#28a745' },
                                    { label: 'Manual Deposits', value: summary.deposits_manual, color: '#ffc107' },
                                    { label: 'Total Added', value: summary.deposits_total, color: '#0d6efd' },
                                    { label: 'Withdrawals (Accepted)', value: summary.withdrawals_accepted, color: '#dc3545' },
                                    { label: 'Net Earnings', value: summary.net, color: summary.net >= 0 ? '#6f42c1' : '#dc3545' },
                                ].map((s) => (
                                    <div className='col-md' key={s.label}>
                                        <div style={{ border: `2px solid ${s.color}`, borderRadius: '8px', padding: '12px', textAlign: 'center' }}>
                                            <div style={{ fontSize: '13px', color: '#666', marginBottom: '4px' }}>{s.label}</div>
                                            <div style={{ fontSize: '22px', fontWeight: 'bold', color: s.color }}>₹{s.value}</div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}

                    <div className='card p-3 flex align-center space-between'>
                        <div className="d-flex justify-content-between align-items-center w-100 mb-3">
                            <h4 className="card-title text-left mb-0">
                                Deposit Requests{filteredList?.length > 0 ? ` (Total: ₹${totalAmount})` : ''}
                            </h4>
                            <input type="text" placeholder="Search name, mobile or txn id..." value={search} onChange={e => { setSearch(e.target.value); setPage(1) }} style={{ width: '260px', padding: '3px 8px', borderRadius: '4px', border: '1px solid #ccc', fontSize: '16px' }} />
                        </div>
                        <div className='row w-100'>
                            <table className="table table-bordered" id="dataTable" width="100%" cellSpacing="0" cellPadding="0">
                                <thead>
                                    <tr>
                                        <th>ID</th>
                                        <th>Name</th>
                                        <th>Mobile</th>
                                        <th>Amount</th>
                                        <th>Transaction ID</th>
                                        <th>Reference ID</th>
                                        <th>Date</th>
                                        <th>Status</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {pagedList?.length === 0 ? (
                                        <tr><td colSpan="9" className="text-center">No deposit requests</td></tr>
                                    ) : pagedList?.map((item) => (
                                        <tr key={item?.id}>
                                            <td>{item?.id}</td>
                                            <td>
                                                <span className="link" style={{ color: '#0d6efd', cursor: 'pointer', textDecoration: 'underline' }} onClick={() => navigate('/user-details', { state: { id: item?.user_id } })}>
                                                    {item?.user_id__first_name || "NA"}
                                                </span>
                                            </td>
                                            <td>{item?.user_id__phone_number || "NA"}</td>
                                            <td>₹{item?.amount}</td>
                                            <td style={{ wordBreak: 'break-all' }}>{item?.transaction_id || "NA"}</td>
                                            <td style={{ wordBreak: 'break-all' }}>{item?.transaction_referral_id || "NA"}</td>
                                            <td>{moment(item?.created_at).format("DD-MM-YYYY, h:mm a")}</td>
                                            <td><span className={`btnspan ${STATUS_CLASS[item?.status] || ''}`}>{item?.status}</span></td>
                                            <td>
                                                {item?.status === 'PENDING' ? (
                                                    <div className="d-flex" style={{ gap: '6px' }}>
                                                        <button type="button" className="btn btn-success btn-sm" onClick={() => handleAction(item, 'APPROVE')}>Approve</button>
                                                        <button type="button" className="btn btn-danger btn-sm" onClick={() => handleAction(item, 'REJECT')}>Reject</button>
                                                    </div>
                                                ) : '-'}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <div className="small text-muted mb-1 mt-2">Showing {filteredList?.length === 0 ? 0 : (page - 1) * PAGE_SIZE + 1}–{Math.min(page * PAGE_SIZE, filteredList?.length || 0)} of {filteredList?.length || 0} entries</div>
                            <Pagination page={page} totalPages={totalPages} onPageChange={setPage} />
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default PendingDeposits
